import type { CycleEvaluationDashboardTab } from '@/types/cycle-evaluation/CycleEvaluationDashboardTab';

import { useNavigate } from '@/hooks/utils/useNavigate';
import { RouteName } from '@/navigation/types';

const OBJECTIVE_CYCLES_TAB: CycleEvaluationDashboardTab = 'objectivePeriods';

/** Opens the tab of the evaluation-cycles page where objective cycles are created and managed. */
export const useOpenObjectiveCycles = () => {
    const navigate = useNavigate();

    return () =>
        navigate({ path: RouteName.CycleEvaluation, state: { tab: OBJECTIVE_CYCLES_TAB } });
};
